import React, { FunctionComponent, useCallback, useMemo, useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { ISelectableRealestate } from "src/stores/RealestateStore";
import { AddRealestatesModal } from "src/components/realestates/add-realestates-modal/AddRealestatesModal";

type AddNewsRealestatesButtonProps = {
    realestates: ISelectableRealestate[];
    isCondominium: boolean;
    onChange: (realestates: ISelectableRealestate[]) => void;
    className?: string;
};

// Opens the modal to add realestates to the news, like the button of the assemblies.
const AddNewsRealestatesButtonBase: FunctionComponent<AddNewsRealestatesButtonProps> = ({
    realestates,
    isCondominium,
    onChange,
    className
}) => {
    const { t } = useTranslation();
    const [isAddRealestatesModalDisplayed, setIsAddRealestatesModalDisplayed] = useState<boolean>(false);

    const selectedRealestateIds = useMemo(() => realestates.map((realestate) => realestate.id), [realestates]);

    const onAddRealestates = useCallback(
        (addedRealestates: ISelectableRealestate[]) => {
            onChange([...realestates, ...addedRealestates]);
        },
        [onChange, realestates]
    );

    const onOpenAddRealestatesModal = useCallback(() => {
        setIsAddRealestatesModalDisplayed(true);
    }, []);

    const onCloseAddRealestatesModal = useCallback(() => {
        setIsAddRealestatesModalDisplayed(false);
    }, []);

    return (
        <>
            <UI.Button
                label={t("screens.realestate.news_edit.add_realestates")}
                onClick={onOpenAddRealestatesModal}
                className={className}
            />
            <AddRealestatesModal
                show={isAddRealestatesModalDisplayed}
                isCondominium={isCondominium}
                selectedRealestateIds={selectedRealestateIds}
                onAdd={onAddRealestates}
                onClose={onCloseAddRealestatesModal}
            />
        </>
    );
};

export const AddNewsRealestatesButton = observer(AddNewsRealestatesButtonBase);
